export const MAX_UPLOAD_SIZE_BYTE = 41943040; // => 8MB
export const MAX_UPLOAD_SIZE_BYTE_WITH_VIDEO = 524288000; // => 100MB
export const FILE_NAME_DOWNLOAD = 'File download';
export const FILE_IMAGE_DOWNLOAD = 'fun_image';
export const FILE_GIF_DOWNLOAD = 'fun_gif';
export const FILE_VIDEO_DOWNLOAD = 'fun_video';
export const CONTENT_TYPES = {
  PNG: 'image/png',
  MP4: 'video/mp4',
  GIF: 'image/gif',
  JPEG: 'image/jpeg',
};

export const MEDIA_TYPES = {
  IMAGE: '1',
  VIDEO: '2',
  GIF: '3',
};

export const MEDIA_MIME_MAPPING_TYPES = {
  [MEDIA_TYPES.IMAGE]: ['image/png', 'image/jpeg', 'image/gif'],
  [MEDIA_TYPES.VIDEO]: ['video/mp4', 'video/quicktime'],
};

export const MEDIA_EXT_MAPPING_TYPES = {
  [MEDIA_TYPES.IMAGE]: ['.png', '.jpg'],
  [MEDIA_TYPES.VIDEO]: ['.mp4'],
  [MEDIA_TYPES.GIF]: ['.gif'],
};
